import React from 'react';
import { useTranslation } from 'react-i18next';

const StatsSection = () => {
  const { t } = useTranslation();
  
  return (
    <section style={{ padding: '80px 7.6923%', background: '#FAFAFA' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <p style={{ color: 'rgba(13, 44, 34, 0.5)', fontSize: '14px', marginBottom: '16px', textTransform: 'uppercase', letterSpacing: '1.5px', fontWeight: '500' }}>
          {t('stats.label1')}
        </p>
        <p style={{ color: '#E5A93D', fontSize: '14px', marginBottom: '24px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '1.5px' }}>
          {t('stats.label2')}
        </p>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px' }}>
          {[
            { label: t('stats.mbaLabel'), value: t('stats.mba') },
            { label: t('stats.successLabel'), value: t('stats.successRate') },
            { label: t('stats.deliveryLabel'), value: t('stats.delivery') }
          ].map((stat, idx) => (
            <div
              key={idx}
              style={{
                background: '#F7F5F0',
                border: '1px solid rgba(13, 44, 34, 0.1)',
                padding: '32px',
                borderRadius: '16px'
              }}
            >
              <div style={{ fontSize: '48px', fontWeight: '700', color: '#0D2C22', marginBottom: '8px' }}>
                {stat.value}
              </div>
              <div style={{ fontSize: '12px', color: 'rgba(13, 44, 34, 0.7)', textTransform: 'uppercase', letterSpacing: '1px', fontWeight: '600' }}>
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;